/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { FinancialCreateFinancialResponse } from "./FinancialCreateFinancialResponse";

export type FinancialCreateFinancialResponseApiRespoonse = {
  data?: FinancialCreateFinancialResponse;
  status?: FinancialCreateFinancialResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace FinancialCreateFinancialResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
